<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <div class="step-bar-container">
          <ul>
            <li class="li-step">
              <span class="stepnum num01"></span>
              <span class="steptext">条件入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num02"></span>
              <span class="steptext">見積り確認</span>
            </li>
            <li class="li-step active">
              <span class="stepnum num03"></span>
              <span class="steptext">連絡先入力</span>
            </li>
            <li class="li-step">
              <span class="stepnum num04"></span>
              <span class="steptext">最終確認</span>
            </li>
          </ul>
        </div>

        <div class="section white-panel mb2p pb8" v-if="pitlockCalendar.canUsePitlock && pitlockCalendar.visible">
            <div class="option-select-date">
            <p class="fs16 font-weight-bold mb0">日時選択</p>
            <p class="text-right" @click="$emit('dontSelectSchedule')">
              <a>日時を選択せずに進む</a>
            </p>
            </div>
          <div tabindex="0" class="calendar-date-panel">
            <div class="calendar-header">
                <div @click="$emit('previousCalendar')">
                  <span class="calendar-header-btn back"></span>
                </div>
                <p class="calendar-ym-select text-center fs14 mb0">{{ pitlockCalendar.visibleYyyyMm }}</p>
                <div @click="$emit('nextCalendar')">
                  <span class="calendar-header-btn next"></span>
                </div>
            </div>
            <div class="calendar-body">
              <table class="calendar-table" cellspacing="0" role="grid">
                <thead>
                  <tr role="row">
                    <th title="日" class="calendar-column-header"><span class="calendar-column-header-inner">日</span></th>
                    <th title="月" class="calendar-column-header"><span class="calendar-column-header-inner">月</span></th>
                    <th title="火" class="calendar-column-header"><span class="calendar-column-header-inner">火</span></th>
                    <th title="水" class="calendar-column-header"><span class="calendar-column-header-inner">水</span></th>
                    <th title="木" class="calendar-column-header"><span class="calendar-column-header-inner">木</span></th>
                    <th title="金" class="calendar-column-header"><span class="calendar-column-header-inner">金</span></th>
                    <th title="土" class="calendar-column-header"><span class="calendar-column-header-inner">土</span></th>
                  </tr>
                </thead>
                <tbody class="calendar-tbody">
                  <template v-for="(week) in pitlockCalendar.visible" :key="week.index">
                    <tr role="row" class="">
                      <template v-for="(day, index) in week.row">
                        <td class="calendar-cell" v-bind:class="{ 'disabled-cell': !day.display || day.pastDay, 'selected-cell': pitlockCalendar.day.activeIndex === `${day.weekNumber}-${index}` }" @click="$emit('dayClick', index, day)">
                          <div class="calendar-date">{{ day.displayDay }}</div>
                          <div class="calendar-info"><span class="reserve-table-ic" v-if="day.displayDay && !day.pastDay" v-bind:class="{ 'selectable': day.display && pitlockCalendar.day.activeIndex !== index, 'unselectable': !day.display, 'selected': pitlockCalendar.day.activeIndex === `${day.weekNumber}-${index}`  }"></span></div>
                        </td>
                      </template>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <p class="text-center mb8"><span class="down-arrow"></span></p>
          <p class="fs13 mb4">日付を選択すると、予約可能な時刻の一覧が表示されます</p>
          <p class="fs13 mb4 font-weight-bold" v-if="pitlockSlots.yyyyMmDd">{{ pitlockSlots.yyyyMmDd }}の空き状況</p>
          <p class="mt4 mb4 error" v-if="pitlockSlots.error">{{ form.pitlockTimeErrorMessage }}</p>
              <table id="pitlockTime" class="time-table" cellspacing="0" role="grid" v-bind:class="{ 'time-table-error': form.pitlockTimeErrorMessage && pitlockSlots.error }">
                <tbody class="time-tbody">
                  <template v-for="(list) in pitlockSlots.list" :key="list.index">
                    <tr role="row" class="">
                      <template v-for="(time, index) in list.row" :key="time.index">
                        <td class="time-cell" v-bind:class="{ 'disabled-cell': !time.reception_hour || time.available_type === 0, 'selected-cell': pitlockSlots.time.activeIndex === `${time.row_number}-${index}` }" @click="$emit('timeClick', index, time)">
                          <div class="time-date">{{time.reception_hour}}</div>
                          <div class="time-info">
                            <span v-if="time.reception_hour" v-bind:class="{ 'unselectable': time.available_type === 0, 'selectable': time.available_type === 1 && pitlockSlots.time.activeIndex !== `${time.row_number}-${index}`, 'selected': pitlockSlots.time.activeIndex === `${time.row_number}-${index}`, 'reserve-table-ic': time.available_type !== 2 }">{{ time.available_type === 2 ? 'TEL' : '' }}</span>
                          </div>
                        </td>
                      </template>
                    </tr >
                </template>
                </tbody>
              </table>

          <p class="fs13 color-font2" v-if="pitlockSlots.yyyyMmDd">・「TEL」表記時間帯につきましては直接店舗までお電話にてお問い合わせください。番号は下段【車検実施店舗】に記載しております。<br>・この予約日は事前点検日の予約です。</p>
        </div>

        <div id="customerPanel" class="section white-panel mb2p">
          <section class="pb20">
            <h2 class="fs16 font-weight-bold">お客様情報</h2>
          </section>
          <ul class="flex stretch ul-col2">
            <li>
              <section class="pb20">
                <h2 id="lastName" class="fs16 font-weight-bold mb12">姓</h2>
                <input v-model="pitlock.last_name" type="text" placeholder="(例)車検" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.lastNameErrorMessage }">
                <p class="mt8 mb0 error">{{form.lastNameErrorMessage}}</p>
              </section>
            </li>
            <li>
              <section class="pb20">
                <h2 id="firstName" class="fs16 font-weight-bold mb12">名</h2>
                <input v-model="pitlock.first_name" type="text" placeholder="(例)太郎" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.firstNameErrorMessage }">
                <p class="mt8 mb0 error">{{form.firstNameErrorMessage}}</p>
              </section>
            </li>
          </ul>
          <section class="pb20">
            <h2 id="tel" class="fs16 font-weight-bold mb12">連絡先の電話番号</h2>
            <input v-model="inspection.tel" type="tel" placeholder="(例)09012345678" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.telErrorMessage }">
            <p class="mt8 mb0 error">{{form.telErrorMessage}}</p>
          </section>
          <section class="pb20">
            <h2 id="userRequest" class="fs16 font-weight-bold">備考(任意)</h2>
             <p class="color-font2">連絡する時間帯や整備・点検のご要望・紹介コード</p>
            <textarea v-model="inspection.user_request" name="" id="" cols="30" rows="4" placeholder="(例)平日18時以降の連絡を希望します。エアコンの調子が悪いので点検・修理をお願いしたいです" class="fs14 pl-text-left w100p" v-bind:class="{ 'error': form.userRequestErrorMessage }"></textarea>
            <p class="mt8 mb0 error">{{form.userRequestErrorMessage}}</p>
          </section>
          <section class="pb20">
            <h2 class="fs16 font-weight-bold mb4">代車のご利用</h2>
            <p class="color-font2">代車料金が見積りと別途かかります</p>
            <fieldset class="radio-check text-left">
              <input id="item-1" class="radio-inline_input" type="radio" name="radio" value=true v-model="inspection.replacement_vehicle_requested">
              <label class="radio-inline_label" for="item-1">必要</label>
              <input id="item-2" class="radio-inline_input" type="radio" name="radio" value=false checked="checked" v-model="inspection.replacement_vehicle_requested">
              <label class="radio-inline_label" for="item-2">不要</label>
            </fieldset>
          </section>
          <div class="bg-gray1 pd12">
            <p class="fs13 line-height1_6 mb4 color-font2">車検所要時間の目安</p>
            <p class="fs13 line-height1_6 mb0 color-font2">{{ ssInfo.carcare_duration_standard }}</p>
          </div>
        </div>
        <section class="section white-panel pb0 pr0">
          <h2 class="fs16 font-weight-bold">車検実施店舗</h2>
          <table class="table w100p fs14">
            <tbody>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12 w25p">店舗名</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.ss_name }}</td>
              </tr>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">住所</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.address }}</td>
              </tr>
              <tr>
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">電話番号</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p disable-auto-tel">{{ ssInfo.tel }}</td>
              </tr>
              <tr v-if="ssInfo.opening_hours_weekday || ssInfo.opening_hours_saturday || ssInfo.opening_hours_sunday || ssInfo.opening_hours_holiday">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">営業時間</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">
                  <template v-if="ssInfo.opening_hours_weekday">平日 {{ ssInfo.opening_hours_weekday }}<br></template>
                  <template v-if="ssInfo.opening_hours_saturday">土曜 {{ ssInfo.opening_hours_saturday }}<br></template>
                  <template v-if="ssInfo.opening_hours_sunday">日曜 {{ ssInfo.opening_hours_sunday }}<br></template>
                  <template v-if="ssInfo.opening_hours_holiday">祝日 {{ ssInfo.opening_hours_holiday }}</template></td>
              </tr>
              <tr v-if="ssInfo.opening_hours_carcare">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">カーケア<br>営業時間</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.opening_hours_carcare }}</td>
              </tr>
              <tr v-if="ssInfo.regular_holiday">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">定休日</th>
                <td class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ ssInfo.regular_holiday}}</td>
              </tr>
              <tr v-if="ssInfo.factory_type_flag">
                <th class="bdb-solid-gray1 color-font2 font-weight-normal pb12 pt12">整備工場</th>
                <td v-if="ssInfo.factory_type_flag === 2" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 3" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">{{ssInfo.factory_type_name}}工場</td>
                <td v-else-if="ssInfo.factory_type_flag === 4" class="bdb-solid-gray1 pb12 pt12 pl2p pr2p">提携工場で整備いたします。詳細は店舗へご確認ください。</td>
              </tr>
            </tbody>
          </table>
        </section>

        <div class="section transparent-panel">
          <p class="fs13 text-center font-weight-bold">キャンセルは無料！仮予約を完了しましょう</p>
          <button @click="$emit('toConfirmCheck', inspection, pitlock, form)" class="button fs16 mt8 mb16 pd16 radius200">次へ</button>
          <p class="fs11 text-center font-weight-bold">現時点では、車検予約は<span class="color-red1">確定しておりません。</span><br>店舗より日程調整の<span class="color-red1">お電話をさせて頂きます。</span></p>
        </div>

      </article>
    </div>
  </div>
</template>

<script>

export default {
  data: () => ({
    form: {
      lastNameErrorMessage: '',
      firstNameErrorMessage: '',
      telErrorMessage: '',
      userRequestErrorMessage: '',
      pitlockTimeErrorMessage: ''
    }
  }),
  props: [
    'pitlock',
    'inspection',
    'ssInfo',
    'pitlockCalendar',
    'pitlockSlots'
  ],
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_KIBOUBI_SENTAKU')
  }
}
</script>
